import React from 'react';
import { APP_NAME } from 'configs/AppConfig';

const footerLinks = [
  { label: 'Speak to support', href: 'https://wa.me/6583874453', external: true },
  {
    label: 'Learn about Sotravel',
    href: 'https://lsg5jucq4q6m.sg.larksuite.com/docx/DdM1ddBdnob8bixLADslUJ1MgMb',
    external: true,
  },
  { label: 'Common Q&A', href: 'https://docs.sotravel.com', external: true },
  { label: 'Terms & Conditions', href: '/#', external: false },
  { label: 'Privacy Policy', href: '/#', external: false },
  { label: 'Help Center', href: '/#', external: false },
];

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="tw-flex-shrink-0 tw-border-t tw-border-gray-200 tw-bg-white">
      <div className="tw-py-4 tw-px-4 sm:tw-px-6 lg:tw-px-8">
        <div className="tw-flex tw-flex-col md:tw-flex-row md:tw-items-center md:tw-justify-between tw-gap-4">
          <p className="tw-order-2 md:tw-order-1 tw-text-center md:tw-text-left tw-text-sm tw-text-gray-500">
            &copy; {currentYear} {APP_NAME}. All rights reserved.
          </p>
          <nav className="tw-order-1 md:tw-order-2 tw-flex tw-flex-wrap tw-items-center tw-justify-center md:tw-justify-end tw-gap-x-4 tw-gap-y-2 sm:tw-gap-x-6">
            {footerLinks.map((link) =>
              link.external ? (
                <a
                  key={link.label}
                  href={link.href}
                  target="_blank"
                  rel="noreferrer"
                  className="tw-text-gray-500 hover:tw-text-gray-600 tw-text-sm"
                >
                  {link.label}
                </a>
              ) : (
                <a
                  key={link.label}
                  href={link.href}
                  onClick={(e) => e.preventDefault()}
                  className="tw-text-gray-500 hover:tw-text-gray-600 tw-text-sm"
                >
                  {link.label}
                </a>
              )
            )}
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
